// English translation

const en = {
  "hotel.booking.number": "Number",
  "hotel.booking.bill_to": "Bill To",
  "hotel.booking.booking_date": "Booking Date",
  "hotel.booking.total_amount": "Total Amount",
  "hotel.booking.total_advances": "Advances",
  "hotel.booking.lines": "# Room",
  "hotel.booking.media": "Media",
  "hotel.booking.phone": "Phone",
  "hotel.booking.email": "Email",
  "hotel.booking.chat": "Chat",
  "hotel.booking.walking": "Walk-in",
  "hotel.booking.web": "Web",
  "hotel.booking.channel_manager": "Channel Manager",
  "hotel.booking.ota": "OTA",
  "hotel.booking.travel_cause": "Travel Cause",
  "hotel.booking.contact": "Contact",
  "hotel.booking.meal_plan": "Regimen",
  "hotel.booking.space": "Space",
  "hotel.booking.price_list": "Price List",
  "hotel.booking.payment_term": "Payment Term",
  "hotel.booking.pending_to_pay": "Pending to Pay",
  "hotel.booking.channel": "Channel",
  "hotel.booking.ota_booking_code": "OTA Code",
  "hotel.booking.rate_plan": "Rate Plan",
  "hotel.booking.group": "Group",
  "hotel.booking.corporative": "Corporative",
  "hotel.booking.state": "State",
  "hotel.booking.offer": "Offer",
  "hotel.booking.confirm": "Confirm",
  "hotel.booking.cancelled": "Cancelled",
  "hotel.booking.no_show": "No show",
  "hotel.booking.finished": "Finished",
  "hotel.booking": "BOOKING",
  "hotel.booking.add_rooms": "Add Rooms",
  "hotel.booking.add_rooms.accept": "Accept",
  "hotel.booking.add_payment": "Add Payment",
  "hotel.booking.plan+rate": "Plan + Tax-free rate",
  "hotel.booking.fees_taxes_not_included": "FEES AND TAXES NOT INCLUDED",
  "hotel.booking.msg_iva_foreign":
    "VAT not included for foreigners, upon verification of passport and immigration card at check-in.",
  "hotel.booking.msg_iva": "VAT included from 19%.",
  "hotel.booking.i_foreigner": "I'm foreigner",
  "hotel.booking.i_colombiano": "I'm Colombian",
  "hotel.booking.today": "Today",
  "hotel.booking.confirmed": "Confirmed",
  "hotel.booking.bill": "Bill",
  "hotel.booking.agent": "Agent",
  "hotel.booking.notes": "Notes",
  "hotel.booking.complimentary": "Complimentary",
  "hotel.booking.type_complimentary": "Type Complimentary",
  "hotel.booking.in_house": "In House",
  "hotel.booking.courtesy": "Courtesy",
  "hotel.booking.pax": "PAX",
  "hotel.booking.holder": "Holder",
  "hotel.booking.holder_guest": "Holder / Guest",
  "hotel.booking.guest": "Guest",
  "hotel.booking.blocked": "Blocked",
  "hotel.booking.taxes_exception": "Taxes Exception",
  "hotel.folio.overbooking": "Overbooking",
  "hotel.folio.accept": "Accept",
  "hotel.booking.add_rooms.selector.product": "Category",
  "hotel.booking.add_rooms.selector.unit_price_w_tax": "Price Unit",
  "hotel.booking.add_rooms.selector.available": "Available",
  "hotel.booking.add_rooms.selector.adults": "Adults",
  "hotel.booking.add_rooms.selector.children": "Children",
  "hotel.booking.add_rooms.selector.room": "Room",
  "hotel.booking.add_rooms.selector.add": "Add",
  "hotel.booking.add_rooms.selector.sale_price_taxed": "Price",
  "hotel.booking.add_rooms.selector.discount": "Discount",
  "hotel.booking.add_rooms.nights_quantity": "Nights Qty",
  "hotel.booking.add_rooms.selector.unit_price": "Unit Price",
  "hotel.booking.add_payment.amount": "Amount",
  "hotel.booking.add_payment.voucher": "Voucher",
  "hotel.booking.add_payment.statement": "Statement",
  "hotel.booking.add_payment.pay": "Pay",
  "hotel.booking.advances_payments": "Advances/Payments",
  "hotel.booking.invoices": "Invoices",
  "hotel.booking.add_room.arrival_date": "Arrival Date",
  "hotel.booking.add_room.departure_date": "Departure Date",
  "hotel.booking.add_room.nights_quantity": "Noches",
  "hotel.booking.add_rooms.selector.rooms": "Room",
  "hotel.chart.occupation_room": "Occupation Room",
  "hotel.chart.occupation_today": "Today",
  "hotel.chart.occupation_tomorrow": "Tomorrow",
  "hotel.chart.check_in_today": "Check-In Today",
  "hotel.chart.check_out_today": "Check-Out Today",
  "hotel.chart.occupation_rate": "Occupation Rate",
  "hotel.chart.occupation_rate_today": "Today",
  "hotel.chart.occupation_rate_tomorrow": "Tomorrow",
  "hotel.booking.bill.party": "Tercero",
  "hotel.booking.bill.kind": "Clase",
  "hotel.booking.bill.bill": "Facturar",
  "hotel.booking.bill.add_guest": "Add guest",
  "hotel.booking.bill.add_vehicle_plate": "Add Vehicle Plate",
  "hotel.booking.wiz_payment.voucher": "Voucher",
  "hotel.booking.wiz_payment.statement": "Medio de Pago",
  "hotel.booking.wiz_payment.amount": "Importe",
  "hotel.booking.wiz_payment.notes": "Notes",
  "booking.widget_side.today": "Today",
  "booking.widget_side.tomorrow": "Tomorrow",
  "booking.widget_side_status.revenue_today": "Revenue today",
  "booking.widget_side_status.revenue_tomorrow": "Revenue tomorrow",
  "hotel.booking.lead_origin": "Leads",
  "hotel.booking.wiz_payment.button_pay": "Pay",
  "hotel.booking.undefined": "Indefinido",
  "hotel.booking.environment": "Environment",
  "hotel.booking.update_taxes": "Actualizar Impuestos",
  "hotel.booking.update_taxes.start.accept": "Aceptar",
  "hotel.booking.update_taxes.start.taxes": "Impuestos",
  "hotel.booking.apply_taxes_exception": "Apply Taxes Exception",
  "hotel.booking.add_rooms.selector.accommodation": "Accommodation",
  "hotel.booking.add_rooms.selector.availability": "Availability",
};

export default en;
